import ActionTypes from "../constants";
import * as api from '../api/index';
// import Swal from 'sweetalert2';
// import Router from "next/router";
import Toast from "../components/Toast"

export const getAllVehicleMake = (page,currentRowsPerPage, filter) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getAllVehicleMake(page,currentRowsPerPage, filter).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.GETVEHICLEMAKERSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETVEHICLEMAKERFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETVEHICLEMAKERFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const getVehicleMakeById = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.getVehicleMakeById(id).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            
            dispatch({
                type: ActionTypes.GETVEHICLEMAKERBYIDSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            // Toast.fire({
            //     icon: 'success',
            //     title: 'Login Successful!'
            // })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.GETVEHICLEMAKERBYIDFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.GETVEHICLEMAKERBYIDFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const saveVehicleMake = (data) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.saveVehicleMake(data).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.SAVEVEHICLEMAKERSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Saved Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.SAVEVEHICLEMAKERFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.SAVEVEHICLEMAKERFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const updateVehicleMake = (data, id) => async (dispatch) => {
    // alert('Login Auth Action');
    dispatch({
        type: ActionTypes.LOADING,
        payload: true,
    });
    const response = await api.updateVehicleMake(data, id).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.UPDATEVEHICLEMAKERSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Record Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.UPDATEVEHICLEMAKERFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.UPDATEVEHICLEMAKERFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}

export const toggleVehicleMake = (id) => async (dispatch) => {
    // alert('Login Auth Action');
    // dispatch({
    //     type: ActionTypes.LOADING,
    //     payload: true,
    // });
    const response = await api.toggleVehicleMake(id).then(res => {
        // 
        if (JSON.parse(res).status == 200) {
            // res.status);
            dispatch({
                type: ActionTypes.TOGGLEVEHICLEMAKERSUCCESS,
                payload: JSON.parse(res).data,
            });
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            Toast.fire({
                icon: 'success',
                title: 'Status Updated Successfully!'
            })
        }
        else {
            // alert(JSON.parse(res).title);
            dispatch({
                type: ActionTypes.LOADING,
                payload: false,
            });
            dispatch({
                type: ActionTypes.TOGGLEVEHICLEMAKERFAILED,
                payload: 'err',
            });
        }
    }).catch(err => {
        
        dispatch({
            type: ActionTypes.TOGGLEVEHICLEMAKERFAILED,
            payload: err,
        });
        // dispatch({
        //     type: ActionTypes.LOADING,
        //     payload: false,
        // });
    })
}